import React from 'react';
import { EChartsWrapper } from './echarts-wrapper';
import { createAreaChartOption } from '../lib/chart-options';
import type { ChartData } from '@/entities/dashboard';

interface AreaChartProps {
  data: ChartData;
  height?: number | string;
  className?: string;
  loading?: boolean;
}

export const AreaChart: React.FC<AreaChartProps> = ({ data, height, className, loading }) => {
  const option = createAreaChartOption(data);

  return <EChartsWrapper option={option} height={height} className={className} loading={loading} />;
};
